import {Banner} from '@primer/react'

import styles from './CopilotAccessRequestSuccessBanner.module.css'

type CopilotCodingAgentRequestAccessSuccessBannerProps = {
  actionType?: 'request' | 'enable'
  orgLogin?: string
  onDismiss: () => void
}

export function CopilotCodingAgentRequestAccessSuccessBanner({
  actionType,
  orgLogin,
  onDismiss,
}: CopilotCodingAgentRequestAccessSuccessBannerProps) {
  return (
    <div className={styles.bannerWrapper}>
      <Banner
        variant="success"
        title="Success"
        hideTitle
        description={
          actionType === 'enable'
            ? 'Copilot coding agent is now enabled for everyone with a Copilot license in your organization.'
            : 'Your request to access Copilot coding agent was sent to the admin.'
        }
        onDismiss={onDismiss}
        role="status"
        secondaryAction={
          actionType === 'enable' && orgLogin ? (
            <Banner.SecondaryAction as="a" href={`/organizations/${orgLogin}/settings/copilot/policies`}>
              See policies
            </Banner.SecondaryAction>
          ) : undefined
        }
      />
    </div>
  )
}
